import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs/internal/Observable';
import { MappingFieldsRequestParamDto, SalesforceCampaignDto, SalesforceGeneralSettingsDto, SalesforceLeadownersDto, SalesforceValidateMappingDto, SettingsResponse } from '../../dto';

@Injectable({
    providedIn: 'root',
})
export class SalesforceApiService {
    private readonly url: string = 'service/contactcloud/salesforce';

    constructor(private readonly baseApiService: BaseApiService) {
    }

    authenticate(code: string): Observable<any> {
      return this.baseApiService.post('salesforce/authenticate', {}, { params: { code }});
    }

    logout(): Observable<any> {
      return this.baseApiService.get(`salesforce/logout`);
    }

    export(exportType, leadOwner, campaigns, duplicateResolution, ids, icpIntelJobUUID: string): Observable<any> {
        return this.baseApiService.post(`${this.url}/export`, {
            duplicateResolution: duplicateResolution === 'skip' ? '' : duplicateResolution,
            icpIntelJobUUID,
            exportType,
            leadOwner,
            campaigns,
            ids,
        });
    }

    exportV2(exportType, leadOwner, campaigns, duplicateResolution, ids, icpIntelJobUUID: string) {
        return this.baseApiService.post(`${this.url}/exportV2`, {
            duplicateResolution: duplicateResolution === 'skip' ? '' : duplicateResolution,
            icpIntelJobUUID,
            exportType,
            leadOwner,
            campaigns,
            ids,
        });
    }

    getAccounts(requestBody): Observable<any> {
        return this.baseApiService.post(`${this.url}/accounts`, requestBody);
    }

    getSettings(): Observable<SettingsResponse<SalesforceGeneralSettingsDto>> {
        return this.baseApiService.get(`${this.url}/settings`);
    }

    saveSettings(settings): Observable<any> {
      return this.baseApiService.put(`${this.url}/settings`, settings);
    }

    getLeadOwners(): Observable<SalesforceLeadownersDto[]> {
        return this.baseApiService.get<any>('salesforce/leadowners');
    }

    getCampaigns(): Observable<SalesforceCampaignDto[]> {
        return this.baseApiService.get<any>('salesforce/campaigns');
    }

    exportCompanies(requestBody): Observable<any> {
        return this.baseApiService.post<any>(`${this.url}/companies/export`, requestBody);
    }

    refreshToken(): Observable<any> {
        return this.baseApiService.post('salesforce/refreshToken');
    }

    validateMapping(): Observable<SalesforceValidateMappingDto> {
        return this.baseApiService.get(`${this.url}/validateMapping`);
    }

    validateDuplicates(requestBody): Observable<any> {
        return this.baseApiService.post(`${this.url}/duplicate`, requestBody);
    }

    validateCompaniesDuplicates(requestBody) {
        return this.baseApiService.post(`${this.url}/companies/duplicate`, requestBody);
    }

    getMappingFields(params: MappingFieldsRequestParamDto = {}): Observable<any> {
        const requestParams = params.isAutomation ? { is_automation: true } : {};
        return this.baseApiService.get(`${this.url}/fields`, { params: requestParams });
    }
}
